import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { tap, map, shareReplay, finalize, take, switchMap } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import {
    achievments, experiences, IAreas, ICities, ICountries, IDegrees, IParams, IProviderOffDays,
    IProviderTimes, IProviderTypes, ISearchData,
    ISearchMedicalProvidersPaging, ISpecialties, ITimesParams, providerAppointmentResponse,
    ProviderDetails, qualifications, responseDegrees, IProviderResponse,
}
    from '@ui-components/models';
import { EskaMedicaDataSourceService } from './eska-medica-data-source.service';

@Injectable({
    providedIn: 'root'
})
export class EskaMedicaService {

    private providerDetailsSubject = new BehaviorSubject<ProviderDetails>(null);
    providerDetails$: Observable<ProviderDetails> = this.providerDetailsSubject.asObservable();

    private providerAppointmentSubject = new BehaviorSubject<providerAppointmentResponse>(null);
    providerAppointment$: Observable<providerAppointmentResponse> = this.providerAppointmentSubject.asObservable();


    private provTypeSubject = new BehaviorSubject<IProviderTypes[]>(null);
    provTypes$: Observable<IProviderTypes[]> = this.provTypeSubject.asObservable();

    private specialtiesSubject = new BehaviorSubject<ISpecialties[]>(null);
    specialties$: Observable<ISpecialties[]> = this.specialtiesSubject.asObservable();

    private countriesSubject = new BehaviorSubject<ICountries[]>(null);
    countries$: Observable<ICountries[]> = this.countriesSubject.asObservable();

    private citiesSubject = new BehaviorSubject<ICities[]>(null);
    cities$: Observable<ICities[]> = this.citiesSubject.asObservable();

    private areasSubject = new BehaviorSubject<IAreas[]>(null);
    areas$: Observable<IAreas[]> = this.areasSubject.asObservable();

    private searchMedicalProvidersSubject = new BehaviorSubject<ISearchMedicalProvidersPaging>(null);
    searchMedicalProviders$: Observable<ISearchMedicalProvidersPaging> = this.searchMedicalProvidersSubject.asObservable();

    private searchDetailsSubject = new BehaviorSubject<ISearchData>(null);
    searchDetails$: Observable<ISearchData> = this.searchDetailsSubject.asObservable();

    private changePoviderTypeSubject = new Subject<IParams>();
    isPoviderTypeChanged$: Observable<IParams> = this.changePoviderTypeSubject.asObservable();

    private providerTimesSubject = new BehaviorSubject<IProviderTimes>(null);
    providerTimes$: Observable<IProviderTimes> = this.providerTimesSubject.asObservable();

    private providerOffDaysSubject = new BehaviorSubject<IProviderOffDays[]>([]);
    providerOffDays$: Observable<IProviderOffDays[]> = this.providerOffDaysSubject.asObservable();

    private providerProfileSubject = new BehaviorSubject<ProviderDetails>(null);
    providerProfile$: Observable<ProviderDetails> = this.providerProfileSubject.asObservable();

    private providerExperienceSubject = new BehaviorSubject<experiences>(null);
    providerExperience$: Observable<experiences> = this.providerExperienceSubject.asObservable();

    private providerQualificationsSubject = new BehaviorSubject<qualifications>(null);
    providerQualifications$: Observable<qualifications> = this.providerQualificationsSubject.asObservable();

    private providerAchievmentsSubject = new BehaviorSubject<achievments>(null);
    providerAchievments$: Observable<achievments> = this.providerAchievmentsSubject.asObservable();


    private nocompletedCasesSubject = new BehaviorSubject<IProviderResponse>(null);
    nocompletedCases$: Observable<IProviderResponse> = this.nocompletedCasesSubject.asObservable();

    private noInCompletedCasesSubject = new BehaviorSubject<IProviderResponse>(null);
    noInCompletedCases$: Observable<IProviderResponse> = this.noInCompletedCasesSubject.asObservable();

    private registerdClaimsSubject = new BehaviorSubject<IProviderResponse>(null);
    registerdClaims$: Observable<IProviderResponse> = this.registerdClaimsSubject.asObservable();

    private noOfpatientsSubject = new BehaviorSubject<IProviderResponse>(null);
    noOfpatients$: Observable<IProviderResponse> = this.noOfpatientsSubject.asObservable();

    private claimsListSubject = new BehaviorSubject<IProviderResponse>(null);
    claimsList$: Observable<IProviderResponse> = this.claimsListSubject.asObservable();

    private financialRecordsSubject = new BehaviorSubject<IProviderResponse>(null);
    financialRecords$: Observable<IProviderResponse> = this.financialRecordsSubject.asObservable();


    private allDegreesSubject = new BehaviorSubject<IDegrees[]>(null);
    allDegrees$: Observable<IDegrees[]> = this.allDegreesSubject.asObservable();

    private chartSubject = new BehaviorSubject<any>(null);
    chart$: Observable<any> = this.chartSubject.asObservable();

    private userFilesSubject = new BehaviorSubject<any>(null);
    userFiles$: Observable<any> = this.userFilesSubject.asObservable();

    providerTypeData = {
        providerTypeId: -1,
        specialtyId: -1,
        countryCode: "JO",
        cityCode: "",
        areaCode: "",
        isFormHide: false,
        loading: false,
        culture: ''
    }

    constructor(private dataSourceService: EskaMedicaDataSourceService,
        private httpClient: HttpClient) {

    }
    getUsedSiteCultures() {
        return this.httpClient.get(`/Sites/GetUsedSiteCulturesByStatus/${2}`)
    }

    getProviderDetails(id, provider) {
        return this.dataSourceService.invokeDataSource(id, provider).pipe(
            tap((x: ProviderDetails) => {
                if (Object.keys(x).length > 0) {
                    this.providerDetailsSubject.next(x)
                }
            })
        );
    }
    getProviderAppointment(id, provider, date?) {
        // return this.providerAppointment$.pipe(
        //   take(1),
        //   switchMap((res) => {
        //     if (res) {
        //       return of(res)
        //     }
        let data = {
            providerId: provider,
            appointmentDate: date ? this.formatDate(date) : this.formatDate(new Date())
        }

        return this.dataSourceService.invokeDataSource(id, data).pipe(
            map((x: any) => {
                if (x && x.data && x.data.length > 0) {
                    return x.data
                } else return of([])
            }),
            tap((x: providerAppointmentResponse) => {
                this.providerAppointmentSubject.next(x)
            }),
            shareReplay()
        );
        // })
        // )

    }


    getAppointments() {
        return this.httpClient.get(`http://192.168.0.92/CareNetApps/Oracle/CareNet.Core.Web.API/api/Appointment/GetProviderAppointment?providerId=51366&appointmentDate=14%2F03%2F2022`)
    }

    getProviderTypes(id) {
        return this.provTypes$.pipe(
            take(1),
            switchMap((res) => {
                if (res) {
                    return of(res)
                }
                return this.dataSourceService.invokeDataSource(id).pipe(
                    tap((x: IProviderTypes[]) => x && this.provTypeSubject.next(x))
                );
            }), shareReplay()
        )
    }

    getSpecialties(id) {

        return this.specialties$.pipe(
            take(1),
            switchMap((res) => {
                if (res) {
                    return of(res)
                }
                return this.dataSourceService.invokeDataSource(id).pipe(
                    tap((x: ISpecialties[]) => x && this.specialtiesSubject.next(x))
                );
            }), shareReplay()
        )


    }
    getCountries(id, data) {
        return this.countries$.pipe(
            take(1),
            switchMap((res) => {
                if (res) {
                    return of(res)
                }
                return this.dataSourceService.invokeDataSource(id, data).pipe(
                    tap((x: ICountries[]) => x && this.countriesSubject.next(x))
                );

            }), shareReplay()
        )

    }
    getCities(id, data) {
        return this.dataSourceService.invokeDataSource(id, data).pipe(
            tap((x: ICities[]) => x && this.citiesSubject.next(x))
        );
    }
    getAreas(id, data) {
        if (data.cityCode == -1) {
            this.areasSubject.next([])
            return of([])
        }
        return this.dataSourceService.invokeDataSource(id, data).pipe(
            tap((x: IAreas[]) => x && this.areasSubject.next(x))
        );
    }

    searchMedicalProvidersPaging(data: IParams) {
        return this.dataSourceService.invokeDataSource(data.sourceId, data).pipe(
            tap((x: ISearchMedicalProvidersPaging) => x && this.searchMedicalProvidersSubject.next(x)),
            finalize(() => this.providerTypeData.loading = false)
        );
    }

    getProviderTimeSlotes(id, data: ITimesParams) {
        return this.dataSourceService.invokeDataSource(id, data).pipe(
            tap((x: IProviderTimes) => x && this.providerTimesSubject.next(x))
        );
    }

    getOffDays(id, provider) {
        return this.dataSourceService.invokeDataSource(id, provider).pipe(
            tap((x: IProviderOffDays[]) => x && this.providerOffDaysSubject.next(x))
        );
    }

    changePoviderType(data: IParams) {
        this.providerTypeData.providerTypeId = data.providerType;
        this.providerTypeData.isFormHide = false;
        this.changePoviderTypeSubject.next(data);
    }

    getSearchDetails(id, provider) {
        return this.dataSourceService.invokeDataSource(id, provider).pipe(
            tap((x: ISearchData) => {
                if (Object.keys(x).length > 0) {
                    this.searchDetailsSubject.next(x)
                    this.providerTypeData.isFormHide = true;
                }
            }), finalize(() => this.providerTypeData.loading = false)
        );


    }

    requestAnappointment(id, data, file?) {
        // let urlWithAttachment = `http://192.168.0.92/CareNetApps/Oracle/CareNet.Core.Web.API/api/Appointment/RequestAnappointmentWithAttachment?`;
        // let url = `http://192.168.0.92/CareNetApps/Oracle/CareNet.Core.Web.API/api/Appointment/RequestAnappointment?`;

        // let params = `visitType=${data.visitType}&providerId=${data.providerId}&appointmentDate=${data.appointmentDateFormat}&periodFromTo=${data.periodFromTo}&memberName=${data.memberName}&mobileNo=${data.mobileNo}&email=${data.email}&providerLicenseNumber=${data.providerLicenseNumber}&notes=${data.notes}&reason=${data.reason}`
        // let fullurl;
        // if (file) {
        //   const httpOptions = {
        //     headers: new HttpHeaders({
        //       'Content-Type': 'multipart/form-data',
        //     })
        //   };
        //   const formData = new FormData();
        //   formData.append('file', file);
        //   fullurl = urlWithAttachment.concat(params);
        //   return this.httpClient.post(fullurl, formData);
        // } else {
        //   fullurl = url.concat(params);
        //   return this.httpClient.get(fullurl);
        // }
        if (file) {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('obj', JSON.stringify(data));
            return this.dataSourceService.invokeDataSource(id, formData, true);
        } else
            return this.dataSourceService.invokeDataSource(id, data);
    }


    UpdateMedicalProvider(id, data) {
        return this.dataSourceService.invokeDataSource(id, data)
    }

    getProviderExperience(id, data) {
        return this.dataSourceService.invokeDataSource(id, data).pipe(
            tap((x: experiences) => {
                this.providerExperienceSubject.next(x)
            })
        );
    }

    getProviderAchievments(id, data) {
        return this.dataSourceService.invokeDataSource(id, data).pipe(
            tap((x: achievments) => {
                this.providerAchievmentsSubject.next(x)
            })
        );
    }
    getProviderQualifications(id, data) {
        return this.dataSourceService.invokeDataSource(id, data).pipe(
            tap((x: qualifications) => {
                this.providerQualificationsSubject.next(x)
            })
        );
    }



    getDegrees(id) {

        return this.allDegrees$.pipe(
            take(1),
            switchMap((res) => {
                if (res) {
                    return of(res)
                }

                return this.dataSourceService.invokeDataSource(id).pipe(
                    map((x: responseDegrees) => {
                        if (x && x.data && x.data.length > 0) {
                            return x.data
                        } else return of([])
                    }),
                    tap((x: IDegrees[]) => {
                        this.allDegreesSubject.next(x)
                    }),
                    shareReplay()
                );
            })
        )


    }

    uploadFile(id, file) {
        const formData = new FormData();
        formData.append('file', file);
        return this.dataSourceService.invokeDataSource(id, formData, true);
    }

    nocompletedCases(id, provId, chartId, chartProcedure, fromIssueDate?, toIssueDate?) {
        let data = {
            "ChartId": chartId,
            "ChartType": null,
            "ChartProcedure": chartProcedure,
            "ProviderId": provId,
            "FromIssueDate": fromIssueDate ? fromIssueDate : null,
            "ToIssueDate": toIssueDate ? toIssueDate : null,
            "DashboardModule": 2
        }


        return this.nocompletedCases$.pipe(
            take(1),
            switchMap((res) => {
                if (res && !fromIssueDate) {
                    return of(res)
                }
                return this.dataSourceService.invokeDataSource(id, data).pipe(
                    map((x: IProviderResponse) => {
                        if (x && x.data && Object.keys(x.data).length > 0) {
                            return x.data
                        } else return of({})
                    }),
                    tap((x: any) => {
                        this.nocompletedCasesSubject.next(x)
                    }),
                    shareReplay()
                );
            })
        )



    }
    noInCompletedCases(id, provId, chartId, chartProcedure, fromIssueDate?, toIssueDate?) {
        let data = {
            "ChartId": chartId,
            "ChartType": null,
            "ChartProcedure": chartProcedure,
            "ProviderId": provId,
            "FromIssueDate": fromIssueDate ? fromIssueDate : null,
            "ToIssueDate": toIssueDate ? toIssueDate : null,
            "DashboardModule": 2
        }

        return this.noInCompletedCases$.pipe(
            take(1),
            switchMap((res) => {
                if (res && !fromIssueDate) {
                    return of(res)
                }
                return this.dataSourceService.invokeDataSource(id, data).pipe(
                    map((x: IProviderResponse) => {
                        if (x && x.data && Object.keys(x.data).length > 0) {
                            return x.data
                        } else return of({})
                    }),
                    tap((x: any) => {
                        this.noInCompletedCasesSubject.next(x)
                    }),
                    shareReplay()
                );
            })
        )


    }
    registerdClaims(id, provId, chartId, chartProcedure, fromIssueDate?, toIssueDate?) {
        let data = {
            "ChartId": chartId,
            "ChartType": null,
            "ChartProcedure": chartProcedure,
            "ProviderId": provId,
            "FromIssueDate": fromIssueDate ? fromIssueDate : null,
            "ToIssueDate": toIssueDate ? toIssueDate : null,
            "DashboardModule": 2
        }

        return this.registerdClaims$.pipe(
            take(1),
            switchMap((res) => {
                if (res && !fromIssueDate) {
                    return of(res)
                }
                return this.dataSourceService.invokeDataSource(id, data).pipe(
                    map((x: IProviderResponse) => {
                        if (x && x.data && Object.keys(x.data).length > 0) {
                            return x.data
                        } else return of({})
                    }),
                    tap((x: any) => {
                        this.registerdClaimsSubject.next(x)
                    }),
                    shareReplay()
                );
            })
        )

    }
    noOfpatients(id, provId, chartId, chartProcedure, fromIssueDate?, toIssueDate?) {
        let data = {
            "ChartId": chartId,
            "ChartType": null,
            "ChartProcedure": chartProcedure,
            "ProviderId": provId,
            "FromIssueDate": fromIssueDate ? fromIssueDate : null,
            "ToIssueDate": toIssueDate ? toIssueDate : null,
            "DashboardModule": 2
        }


        return this.noOfpatients$.pipe(
            take(1),
            switchMap((res) => {
                if (res && !fromIssueDate) {
                    return of(res)
                }
                return this.dataSourceService.invokeDataSource(id, data).pipe(
                    map((x: IProviderResponse) => {
                        if (x && x.data && Object.keys(x.data).length > 0) {
                            return x.data
                        } else return of({})
                    }),
                    tap((x: any) => {
                        this.noOfpatientsSubject.next(x)
                    }),
                    shareReplay()
                );
            })
        )


    }


    claimsList(id, provId, chartId, chartProcedure, fromIssueDate?, toIssueDate?) {
        let data = {
            "ChartId": chartId,
            "ChartType": null,
            "ChartProcedure": chartProcedure,
            "ProviderId": provId,
            "FromIssueDate": fromIssueDate ? fromIssueDate : null,
            "ToIssueDate": toIssueDate ? toIssueDate : null,
            "DashboardModule": 2
        }

        return this.claimsList$.pipe(
            take(1),
            switchMap((res) => {
                if (res && !fromIssueDate) {
                    return of(res)
                }
                return this.dataSourceService.invokeDataSource(id, data).pipe(
                    map((x: IProviderResponse) => {
                        if (x && x.data && Object.keys(x.data).length > 0) {
                            return x.data
                        } else return of({})
                    }),
                    tap((x: any) => {
                        this.claimsListSubject.next(x)
                    }),
                    shareReplay()
                );
            })
        )


    }
    financialRecords(id, provId, chartId, chartProcedure, fromIssueDate?, toIssueDate?) {
        let data = {
            "ChartId": chartId,
            "ChartType": null,
            "ChartProcedure": chartProcedure,
            "ProviderId": provId,
            "FromIssueDate": fromIssueDate ? fromIssueDate : null,
            "ToIssueDate": toIssueDate ? toIssueDate : null,
            "DashboardModule": 2
        }

        return this.financialRecords$.pipe(
            take(1),
            switchMap((res) => {
                if (res && !fromIssueDate) {
                    return of(res)
                }
                return this.dataSourceService.invokeDataSource(id, data).pipe(
                    map((x: IProviderResponse) => {
                        if (x && x.data && Object.keys(x.data).length > 0) {
                            return x.data
                        } else return of({})
                    }),
                    tap((x: any) => {
                        this.financialRecordsSubject.next(x)
                    }),
                    shareReplay()
                );
            })
        )


    }
    topFiveChart(id, provId, chartId, chartProcedure, chartType, fromIssueDate?, toIssueDate?) {
        let data = {
            "ChartId": chartId,
            "ChartType": chartType,
            "ChartProcedure": chartProcedure,
            "ProviderId": provId,
            "FromIssueDate": fromIssueDate ? fromIssueDate : null,
            "ToIssueDate": toIssueDate ? toIssueDate : null,
            "DashboardModule": 2
        }
        return this.chart$.pipe(
            take(1),
            switchMap((res) => {
                if (res && !fromIssueDate) {
                    return of(res)
                }
                return this.dataSourceService.invokeDataSource(id, data).pipe(
                    map((x: IProviderResponse) => {
                        if (x && x.data && Object.keys(x.data).length > 0) {
                            return x.data
                        } else return of({})
                    }),
                    tap((x: any) => {
                        this.chartSubject.next(x)
                    }),
                    shareReplay()
                );
            })
        )

    }

    saveForm(formData: any, pageData) {
        return this.httpClient.post(`/Forms/SaveFormNew/${pageData.id}/${pageData.componentSettingsId}/${pageData.culture}`, formData);
    }
    sendCode(data, requestOptions) {
        return this.httpClient.post(`/Account/SendCode`, data, requestOptions)
    }
    VerifyCode(data, requestOptions) {
        return this.httpClient.post(`/Account/VerifyCode`, data, requestOptions)
    }
    getUserFiles(data) {
        return this.httpClient.get('/UserMedia/GetUserFiles/' + data.licenseNo).pipe(
            tap((res: any) => {
                if (res && res.length > 0) {
                    let galleryImages = []
                    res.forEach(media => {
                        galleryImages.push({
                            small: location.origin + '/' + media.publicUrl.replaceAll("\\", "/"),
                            medium: location.origin + '/' + media.publicUrl.replaceAll("\\", "/"),
                            big: location.origin + '/' + media.publicUrl.replaceAll("\\", "/"),
                        });
                    });
                    this.userFilesSubject.next(galleryImages)
                } else {
                    this.userFilesSubject.next([])
                }
            })
        );
    }

    toCamel(o) {
        var newO, origKey, newKey, value
        if (o instanceof Array) {
            return o.map(function (value) {
                if (typeof value === "object") {
                    value = this.toCamel(value)
                }
                return value
            })
        } else {
            newO = {}
            for (origKey in o) {
                if (o.hasOwnProperty(origKey)) {
                    newKey = (origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey).toString()
                    value = o[origKey]
                    if (value instanceof Array || (value !== null && value.constructor === Object)) {
                        value = this.toCamel(value)
                    }
                    newO[newKey] = value
                }
            }
        }
        return newO
    }
    formatDate(date) {
        let dateString = ('0' + date.getDate()).slice(-2) + '/'
            + ('0' + (date.getMonth() + 1)).slice(-2) + '/'
            + date.getFullYear();

        return dateString;
    }
}





